
/**
 * Sets up event tracking on specific element. Uses the 'data-tracking' attribute to determine what to track.
 */

export default class TrackingLayer {
	constructor(query) {
		let isNode = query instanceof HTMLElement,
			elList = isNode ? query : document.querySelectorAll(query);

		if(isNode) {
			this.setElement(elList);
		}

		else {
			[].forEach.call(elList, this.setElement.bind(this));
		}
	}

	/**
	 * Sets up individual elements that have the data-tracking property
	 * @param {[type]} el [description]
	 */
	setElement(el) {
		//autoDetect -> Set only when the element doesn't contain a 'data-tracking' attribute,
		//checks the element's HTML tag to determine what type of tracking to use.
		//If a 'data-tracking' is present, then those properties will  be used instead. 
		let options = el.getAttribute('data-tracking') ? JSON.parse(el.getAttribute('data-tracking')) : {autoDetect: true};

		options.el = el;

		this.setHandler(options);
	}

	/**
	 * Adds a tracking handler to the passed element
	 * @param {[Object]} options:
	 *        el: [Node]
	 *        event: [String] Event to listen to
	 *        type: [String] Optional. Handler for the event 
	 *        report: [String] Value that will be reported for the 'layerVar'
	 *        layerVar: [String] Name of the data layer variable, usually part of a 'layerObj'
	 *        layerObj: [String] Name of the data layer object on which this event will be tracked
	 */
	setHandler(options) {
		options.el.trackingLayer = options.el.trackingLayer || {};

		if(options.el.trackingLayer.initialized) {
			return false;
		}

		let handler,
			eventList;

		if(options.autoDetect) {
			if(options.el.nodeName === 'VIDEO') {
				handler = this.video;
				eventList = 'play pause';

				if (pageContext && (pageContext.ns === 'storefront' || pageContext.ns === 'brandcampaign')) {
					this.addShareEvents.call(handler);
				}
			}

			//If tag is not supported, don't attach anything.
			else {
				return false;
			}
		}

		else {
			//If 'options.type' does not exist as a method, use the default 'eventTracking' method.
			handler   = typeof this[options.type] === 'function' ? this[options.type] : this.eventTracking;
			eventList = options.event || 'click';
		}

		eventList = eventList.trim().split(' ');

		//Attach a listener for each passed event.
		eventList.forEach(function(eventName){
			options.el.addEventListener(eventName, handler.bind(options.el, options));
		});

		options.el.trackingLayer.initialized = true;
	}

	/**
	 * Default tracking method. Just pushes back a report value to the Data Layer
	 * @param  {[String | Boolean]} options.report [property, attribute, or string to report]
	 * @param  {[String]} options.layerVar  [Data Layer variable to report to]
	 * @param  {[String]} options.layerObj [Name of the layer object to attach the variable to. ex: "interactions", "event", etc.]
	 * @param  {[Boolean]} options.asString [DEFAULT: TRUE. Force the data to be pushed as a string]
	 */
	eventTracking(options) {
		//Determines what to push into the data layerVar.
		//First checks for properties, attributes, and Resources then, if all fails, returns the string 
		let reportVal = this[options.report] || this.getAttribute(options.report) || window.Resources[options.report] || options.report,
			dataObj = {};

		options.asString = options.hasOwnProperty('asString') ? options.asString : true;

		//If there's no layer variable, pass as a string for the layer object, 
		if(options.layerVar) {
			if(options.asString) {
				dataObj = options.layerVar + ': ' + reportVal;
			}

			else {
				dataObj[options.layerVar] = reportVal;
			}
		}

		else {
			dataObj = reportVal;
		}

		TrackingLayer.pushData(dataObj, options.layerObj);
	}

	/**
	 * Tracking video interactions
	 */
	video(options, evt) {
		let dataObj = {
			'name': 'N/A',
			'video_src': this.currentSrc,
			'duration': this.duration,
			'current_time': this.currentTime,
			'event': evt.type
		};

		TrackingLayer.pushData(dataObj, 'videoData');
		if (pageContext && (pageContext.ns === 'storefront' || pageContext.ns === 'brandcampaign')) {
			TrackingLayer.pushData('video');
		}
	}

	addShareEvents() {
		$('.js-share-events a').on('click', function () {
			let video = $(this).parents().find('video');

			if (video.length) {
				let dataObj = {
					'name': 'N/A',
					'video_src': video[0].currentSrc,
					'duration': video[0].duration,
					'current_time': video[0].currentTime,
					'event': $(this).attr('title')
				};

				TrackingLayer.pushData(dataObj, 'videoData');
				TrackingLayer.pushData('video');
			}
		});


	}

	static pushData(dataObj, layerObj) {

		if(!window.dataLayer) {
			return false;
		}

		let varsObj = {};

		layerObj = layerObj || 'event';

		varsObj[layerObj] = {};
		
		//If the data is an object, loop through it and add all properties
		//Else, add the direct value to the layer object
		if(dataObj.constructor === Object) {
			for(var key in dataObj) {
				varsObj[layerObj][key] = dataObj[key] && typeof dataObj[key] === 'string' ? dataObj[key].toLowerCase() : dataObj[key];
			}
		}

		else {
			varsObj[layerObj] = dataObj.toLowerCase();
		}

		// console.log(varsObj);
		window.dataLayer.push(varsObj);
	}
}


// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/modules/module.tracking-layer.js